import { render, staticRenderFns } from "./ResourceDropdown.vue?vue&type=template&id=7031dff7"
import script from "./ResourceDropdown.vue?vue&type=script&lang=js"
export * from "./ResourceDropdown.vue?vue&type=script&lang=js"
import style0 from "./ResourceDropdown.vue?vue&type=style&index=0&id=7031dff7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports